import Dashboard from "components/Admin/Dashboard";
import CompanyProfile from "components/Admin/CompanyProfile";
// import UserProfile from "views/UserProfile/UserProfile";
import CompanyList from "components/Admin/Company/CompanyList";
import FestivalList from "components/Admin/Festival/FestivalList";
import AddCompany from "components/Admin/Company/AddCompany";
import CompanyUsersAllList from "components/Admin/CompanyUser/CompanyUsersAllList";
import AddFestival from "components/Admin/Festival/AddFestival";
import EditCompany from "components/Admin/Company/EditCompany";
import EditFestival from "components/Admin/Festival/EditFestival";
import TestComponent from "components/Admin/Company/TestComponent";
import CompanyUserList from "components/Admin/CompanyUser/CompanyUserList";
import Comments from "components/Admin/Comments";
// import CompanyUserListNew from "components/Admin/CompanyUser/CompanyUserListNew";
import FestivalMusicDirectorList from "components/Admin/FestivalMusicDirector/FestivalMusicDirectorList";
import MDMediaList from "components/Admin/FestivalMusicDirector/MDMediaList";
import FestivalAdjudicatorList from "components/Admin/FestivalAdjudicator/FestivalAdjudicatorList";
import FestivalMusicDirectorAllList from "components/Admin/FestivalMusicDirector/FestivalMusicDirectorAllList";
import FestivalAdjudicatorAllList from "components/Admin/FestivalAdjudicator/FestivalAdjudicatorAllList";
import AdminUsers from "components/Admin/Users/AdminUsers";
import EmailTemplatesListing from "components/Admin/EmailTemplates/EmailTemplatesListing";
import dashboardIcon from "assets/img/dashboard.svg";
import companyIcon from "assets/img/company.svg";
import festivalIcon from "assets/img/festival_white.svg";
import musicDirectorIcon from "assets/img/music_director.svg";
import userlIcon from "assets/img/user.svg";
import mailIcon from "assets/img/mail.svg";
import TestimonialList from "../components/Admin/Testimonial/TestimonialList";

var dashboardRoutes = [
  {
    path: "/Admin/dashboard",
    name: "Dashboard",
    icon: "pe-7s-graph",
    component: Dashboard,
    showMenu:true,
    showMenuFront:false,
    iconImagePath:dashboardIcon,
    permission:'both'
  },
  {
    path: "/Admin/Admin-users",
    name: "Admin Users",
    icon: "pe-7s-users",
    iconImagePath:userlIcon,
    component: AdminUsers,
    showMenu:true,
    showMenuFront:false,
    permission:'admin'
  },
  {
    path: "/Admin/:festivalId/Comments",
    name: "Comments",
    icon: "pe-7s-users",
    iconImagePath:userlIcon,
    component: Comments,
    showMenu:false,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/Companies",
    name: "Companies",
    icon: "fa fa-building-o",
    iconImagePath:companyIcon,
    component: CompanyList,
    showMenu:true,
    showMenuFront:false,
    permission:'admin'
  },
  {
    path: "/Admin/Add-Company",
    name: "Add Company",
    icon: "pe-7s-user",
    component: AddCompany,
    showMenu:false,
    showMenuFront:false,
    permission:'admin'
  },
  {
    path: "/Admin/Add-Festival",
    name: "Add Festival",
    icon: "pe-7s-user",
    component: AddFestival,
    showMenu:false,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/Edit-Company/:id",
    name: "Edit Company",
    icon: "pe-7s-user",
    component: EditCompany,
    showMenu:false,
    showMenuFront:false,
    permission:'admin'
  },
  {
    path: "/Admin/Edit-Festival/:id",
    name: "Edit Festival",
    icon: "pe-7s-user",
    component: EditFestival,
    showMenu:false,
    showMenuFront:false,
    permission:'admin'
  },
  {
    path: "/Admin/TestComponent",
    name: "Test Component",
    icon: "pe-7s-user",
    component: TestComponent,
    showMenu:false,
    showMenuFront:false,
    permission:'both'
  },

  {
    path: "/Admin/Company/:company_id/Users",
    name: "Company Users",
    icon: "pe-7s-albums",
    component: CompanyUserList,
    showMenu:false,
    showMenuFront:false,
    permission:'admin'
  },
  {
    path: "/Admin/Company-Users",
    name: "Company Users",
    icon: "fa fa-building-o",
    iconImagePath:companyIcon,
    component: CompanyUserList,
    showMenu:true,
    showMenuFront:false,
    permission:'company'
  },
  // {
  //   path: "/Admin/Company-New-Users",
  //   name: "Company Users New",
  //   icon: "fa fa-building-o",
  //   iconImagePath:companyIcon,
  //   component: CompanyUserListNew,
  //   showMenu:true,
  //   showMenuFront:false,
  //   permission:'company'
  // },
  {
    path: "/Admin/Company/Users",
    name: "Company Users",
    icon: "pe-7s-users",
    iconImagePath:userlIcon,
    component: CompanyUsersAllList,
    showMenu:true,
    showMenuFront:false,
    permission:'admin'
  },
  {
    path: "/Admin/Festival/:festivalId/Music-directors",
    name: "Music Directors",
    icon: "pe-7s-albums",
    component: FestivalMusicDirectorList,
    showMenu:false,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/Festival/:festivalId/Adjudicators",
    name: "Adjudictors",
    icon: "pe-7s-albums",
    component: FestivalAdjudicatorList,
    showMenu:false,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/Festivals",
    name: "Festivals",
    icon: "pe-7s-music",
    iconImagePath:festivalIcon,
    component: FestivalList,
    showMenu:true,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/Festival/Music-directors",
    name: "Music Directors",
    icon: "pe-7s-users",
    iconImagePath:musicDirectorIcon,
    component: FestivalMusicDirectorAllList,
    showMenu:true,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/Festival/Adjudicators",
    name: "Adjudicators",
    icon: "pe-7s-users",
    iconImagePath:musicDirectorIcon,
    component: FestivalAdjudicatorAllList,
    showMenu:true,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/Email-templates",
    name: "Email Templates",
    icon: "fa fa-envelope",
    iconImagePath:mailIcon,
    component: EmailTemplatesListing,
    showMenu:true,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/CompanyProfile",
    name: "Company Profile",
    icon: "pe-7s-user",
    iconImagePath:userlIcon,
    component: CompanyProfile,
    showMenu:true,
    showMenuFront:false,
    permission:'company'
  },
  {
    path: "/Admin/MD-media/:mdId",
    name: "Music Director Media",
    icon: "pe-7s-user",
    iconImagePath:userlIcon,
    component: MDMediaList,
    showMenu:false,
    showMenuFront:false,
    permission:'both'
  },
  {
    path: "/Admin/testimonials",
    name: "Testimonials",
    icon: "pe-7s-users",
    iconImagePath:musicDirectorIcon,
    component: TestimonialList,
    showMenu:true,
    showMenuFront:false,
    permission:'admin'
  },
  { redirect: true, path: "/Admin", to: "/Admin/dashboard", name: "Dashboard" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx